import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../../AppContext";
import IconButton from "../../theme_reuse/IconButton";

interface Props {}
interface State {}

export default class NoteVisibilityModeButton extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  toggleNoteVisibility = () => {
    const noteRow = this.context.chordHistoryOptions.noteRow;
    const hideNotes = !noteRow.hideNotes;
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { noteRow: { ...noteRow, hideNotes } } });
  };

  render(): ReactNode {
    const hideNotes = this.context.chordHistoryOptions.noteRow.hideNotes;
    const icon = <span className="icon-inner-letter">N</span>;
    return (
      <IconButton
        mini
        title={hideNotes ? "Notes are hidden" : "Note are visible"}
        icon={icon}
        strikethrough={hideNotes}
        onClick={this.toggleNoteVisibility}
      />
    );
  }
}

NoteVisibilityModeButton.contextType = AppContextType;
